import { dangerColor, grayColor, formElementColors } from 'assets/jss/material-dashboard-pro-react';

const otpStyle = (theme) => ({
	singleInputWrapper: ({ isNewDashBoardEnabled }) => ({
		width: isNewDashBoardEnabled ? '68px' : '60px',
		padding: '0 6px',
		'& .MuiInput-underline.Mui-error:after': {
			borderBottomColor: dangerColor[0],
		},
		'& > div::before,& > div::after': {
			display: isNewDashBoardEnabled ? 'none' : 'block',
		},
		'& .Mui-error input': {
			border: `1px solid ${formElementColors.error}`,
		},
	}),
	input: {
		'&,&::placeholder': {
			fontSize: theme.fontSize(24),
			fontFamily: theme.fontFamily.alvar.bold,
			fontWeight: 'normal',
			opacity: '1',
			textAlign: 'center',
			padding: '2px 0',
			height: theme.fontSize(40),
		},
	},
	otpWrapper: ({ isNewDashBoardEnabled }) => ({
		display: 'flex',
		margin: '0 -6px',
		marginTop: isNewDashBoardEnabled ? '1.5rem' : '40px',
		marginBottom: '4px',
		flexDirection: theme.direction === 'rtl' ? 'row-reverse' : 'row',
		justifyContent: 'center',
	}),
	newThemedOtpInput: {
		'&': {
			border: `1px solid ${grayColor[0]}`,
			fontSize: theme.fontSize(40),
			borderRadius: '4px',
			height: '56px',
			fontFamily: theme.fontFamily.albert.bold,
		},
	},
	otpContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
});

export default otpStyle;
